/*
 * Copyright © 2019 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import DateUtil from '../utils/DateUtil';
import {TSCockpitSelect} from './enums/TSCockpitSelect';
import {TSCockpitType} from './enums/TSCockpitType';
import moment = require('../../../node_modules/moment/moment');

export default class TSCockpitTypeDTO {
    private _datumVon: moment.Moment | undefined;
    private _datumBis: moment.Moment | undefined;
    private _cockpitSelect: TSCockpitSelect = TSCockpitSelect.LETZER_MONAT;
    private _cockpitType: TSCockpitType = TSCockpitType.GESUCHE_KANTON;
    private _locale: String;

    public get datumVon(): moment.Moment | undefined {
        return this._datumVon;
    }

    public set datumVon(value: moment.Moment | undefined) {
        this._datumVon = value;
    }

    public get datumBis(): moment.Moment | undefined {
        return this._datumBis;
    }

    public set datumBis(value: moment.Moment | undefined) {
        this._datumBis = value;
    }

    public get cockpitSelect(): TSCockpitSelect {
        return this._cockpitSelect;
    }

    public set cockpitSelect(value: TSCockpitSelect) {
        this._cockpitSelect = value;
    }

    public get cockpitType(): TSCockpitType {
        return this._cockpitType;
    }

    public set cockpitType(value: TSCockpitType) {
        this._cockpitType = value;
    }

    public get locale(): String {
        return this._locale;
    }

    public set locale(value: String) {
        this._locale = value;
    }

    serialize(restObject: any): any {
        if (this.datumVon && this.datumBis) {
            restObject.datumVon = DateUtil.momentToLocalDateTime(this.datumVon);
            restObject.datumBis = DateUtil.momentToLocalDateTime(this.datumBis);
        }
        restObject.cockpitSelect = this.cockpitSelect;
        restObject.cockpitType = this.cockpitType;
        restObject.locale = this.locale;

        return restObject;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSCockpitTypeDTO.ts